<template>
  <div id="app">
    <router-view class="router-view"></router-view>
    <loading :value="pageLoading || dataLoading"></loading>
  </div>
</template>
<script>
import { mapState, mapMutations } from "vuex";
import { setStore, getStore, removeStore, modifyJson } from "@/config/mUtils";
import loading from "@/components/common/loading";
export default {
  components: {
    loading,
  },
  data() {
    return {};
  },
  computed: {
    ...mapState(["pageLoading", "dataLoading", "path"]),
  },
  created() {
    this.setCacheData();
  },
  methods: {
    ...mapMutations(["setCacheData"]),
  },
  mounted() {},
};
</script>
<style lang="scss">
.vertical-center-modal {
  display: flex;
  align-items: center;
  justify-content: center;

  .ivu-modal {
    top: 0;
  }
}
#app {
  width: 100%;
  height: 100%;
  background: #fff;
}
.viewer-container {
  position: fixed !important;
  height: 100% !important;
  width: 100% !important;
  z-index: 1000 !important;
}
.clearfix:after {
  content: "";
  display: block;
  height: 0;
  clear: both;
  visibility: hidden;
}
.clearfix {
  *zoom: 1;
}

.el-form-item.is-error {
  margin-bottom: 40px;
}

.el-form-item.is-error .el-form-item__error {
  padding-top: 12px;
}

/* 垂直居中 */
.flex-row {
  display: flex;
  align-items: center;
  flex-direction: row;
}

/* 水平居中 */
.flex-column {
  display: flex;
  align-items: center;
  flex-direction: column;
}

/* 等间距排列，首尾不留白 */
.flex-between {
  display: flex;
  justify-content: space-between;
  flex-direction: row;
}

/* 等间距排列，首尾留白 */
.flex-around {
  display: flex;
  justify-content: space-around;
  flex-direction: row;
}

.textHidden {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  /* ! autoprefixer: off */
  -webkit-box-orient: vertical;
  /* autoprefixer: on */
  -webkit-line-clamp: 2;
  word-break: break-all;
}

@import "src/style/common";
@import "src/icon/icon";
</style>




// WEBPACK FOOTER //
// src/App.vue